module.exports = __webpack_public_path__ + "static/media/bottom_infographic_mobile.5ce56e2a.webp";